// removed by extract-text-webpack-plugin
module.exports = {"poster":"Poster__poster___2Xb2k","posterContainer":"Poster__posterContainer___2AL_9","downloadButton":"Poster__downloadButton___38B5_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Poster.scss
// module id = 727
// module chunks = 1